var bighouse = bighouse || {};

bighouse.locationsMenu = (function () {

    function init() {

        if( $('.js-navHasMegaMenu').length === 0 ){
            return;
        }

        bindEvents();
        updateActiveLocation( $("[class^=js-nav-].u-active") );
    }



    function bindEvents() {
        $("[class^=js-nav-]").on('click', function(e){
            updateActiveLocation(this);
            e.preventDefault();
        });

    }

    function updateActiveLocation(location){
        var allClasses = $(location).attr('class').split(/\s+/);
        let navClass = allClasses.filter( currentClass => currentClass.indexOf('js-nav-') > -1);

        $("[class^=js-nav-].u-active").removeClass('u-active');
        $("." + navClass[0]).addClass('u-active');

        $('.LocationsMenu-region').addClass('u-hide');
        $('.LocationsMenu-region.' + navClass[0]).removeClass('u-hide');
    }


    return {
        init: init
    };
})();